import { BaseAiFeedback, BaseAiSkillFeedback, Interview } from "src/types";
export class InterviewClass {
  interview: Interview;
  constructor(data: Interview) {
    this.interview = data;
  }

  public static defaultFeedback(): Feedback {
    return {
      overall: sample(),
      work_experience: sample(),
      communication: sample(),
      skills: undefined
    };
  }

  getParsedFeedback(): Feedback | undefined {
    const f = this.interview.ai_feedback;
    let _f: Feedback | undefined = undefined;
    if (!f) return _f;
    _f = InterviewClass.defaultFeedback();
    _f.overall = mapFeedback(f.overall, styles[0]);
    _f.work_experience = mapFeedback(f.work_experience, styles[1]);
    _f.communication = mapFeedback(f.communication, styles[2]);
    _f.skills = mapSkillsFeedback(f.skills);
    return _f;
  }
}

export interface FeedbackData {
  score: string;
  summary: string[];
  title: string;
  _score: ReturnType<typeof _getScore>;
}

export interface Feedback {
  communication: FeedbackData;
  work_experience: FeedbackData;
  overall: FeedbackData;
  skills?: SkillsFeedback;
}

const sample = (): FeedbackData => ({
  score: "I",
  summary: [],
  title: "",
  _score: _getScore(0)
});

const getGrade = (score: number) => {
  if (!score) return "Incomplete";
  return Math.round(score * 10) + "%";
};

const mapFeedback = (f: BaseAiFeedback, { title } = { title: "" }): FeedbackData => {
  const score = getGrade(f.grade);
  return {
    summary: f.feedback,
    score,
    title,
    _score: _getScore(f.grade)
  };
};

const mapSkillsFeedback = (skills: BaseAiSkillFeedback) => {
  try {
    const summary = mapFeedback(skills, { title: "Skill Set Based" });
    const { technical, intercultural } = skills;

    // Get base feedback of each type
    const technicalBase = mapFeedback(technical, styles[3]);
    const interculturalBase = mapFeedback(intercultural, styles[4]);

    // Get the list of skills excluding the incomplete ones (Requested to not be shown)
    const technicalS = Object.entries(technical.skills)
      .map(([k, v]) => mapFeedback(v, { title: k }))
      .filter((s) => s.score !== "I");
    const interculturalS = Object.entries(intercultural.skills)
      .map(([k, v]) => mapFeedback(v, { title: k }))
      .filter((s) => s.score !== "I");
    return {
      ...summary,
      technical: { ...technicalBase, skills: technicalS },
      intercultural: { ...interculturalBase, skills: interculturalS }
    };
  } catch (e) {
    console.log(e);
  }
};
export type SkillsFeedback = ReturnType<typeof mapSkillsFeedback>;

const styles = [
  {
    title: "Overall Feedback"
  },
  {
    title: "Relevant Work Experience"
  },
  {
    title: "Communication Skills"
  },
  {
    title: "Technical Skills"
  },
  {
    title: "Intercultural Skills"
  }
];

const _getScore = (score: number) => {
  let color = "#8A8A8A"; // Incomplete
  if (score >= 8) {
    color = "#26993F";
  } else if (score >= 6) {
    color = "#FF914D";
  } else if (score > 0) {
    color = "#D32F2F";
  }
  return { style: { color, borderColor: color } };
};
